export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f9f9fe',
    padding: 41,
    '& .dropzone-preview': {
      width: '100% !important',
    },
    '& .dropzone': {
      width: '100% !important',
    },
    '& > section + section': {
      marginTop: 50,
    },
  },
  whiteBlock: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    marginRight: 11,
    marginLeft: 7,
    '& > *': {
      width: '50%',
    },
    boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.1)',
  },
  childBlock: {
    marginRight: 11,
    marginLeft: 7,
  },
  textWrapper: {
    marginLeft: 20,
  },
  largeText: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontSize: 20,
    fontWeight: '700',
    color: '#011533',
  },
  smallText: {
    fontSize: 14,
    color: '#8A96A0',
  },

  contentWrapper: {
    display: 'flex',
    '& .OnboardingQuizView-existingPitchContainer': {
      display: 'none',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    '& .OnboardingQuizView-fileUploaderContainer': {
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
  },
  contentWrapperWithPitch: {
    '& .OnboardingQuizView-existingPitchContainer': {
      display: 'flex',
      width: '50%',
    },
    '& .OnboardingQuizView-fileUploaderContainer': {
      width: '50%',
      paddingRight: 20,
    },
  },
  pitchUrlContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'none !important',
  },
  hoverOpacity: {
    cursor: 'pointer',
    opacity: '1',
    transition: 'opacity .2s ease',
    '&:hover': {
      opacity: '.6',
    },
  },
  inactive: {
    pointerEvents: 'none',
  },
  quizTitleSection: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '41px',
    overflow: 'hidden',
    '& .title': {
      float: 'left',
    },

    '& .copy-quiz': {
      float: 'right',
      backgroundColor: 'white',
      color: '#000000',
      height: '40px',
      width: 280,
      fontWeight: 700,
      fontSize: '13px !important',
      fontFamily: "'Proxima Nova Alt', sans-serif",
      paddingLeft: '20px !important',
      paddingRight: '20px !important',
      border: ' 1px solid #273754',
      borderRadius: 16,
      textTransform: 'none',
    },
  },
  title: {
    fontSize: 28,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontWeight: '700',
    color: '#011533',
  },
  copyQuizButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 32,
    width: 280,
  },
  buttonDesc: {
    marginLeft: 14,
    width: 100,
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontWeight: '700',
    color: '#0B2456',
  },
  activeType: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '700',
    fontSize: 18,
    color: '#011533',
    fontFamily: "'Proxima Nova Alt', sans-serif",
    borderBottom: '3px solid #004360',
    cursor: 'pointer',
  },
  type: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '700',
    fontSize: 18,
    color: '#011533',
    fontFamily: "'Proxima Nova Alt', sans-serif",
    borderBottom: '1px solid #798498',
    cursor: 'pointer',
  },
  typeSelectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 16,
  },
}
